import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { OpenSalesOrdersTabPanel } from "@/screens/CustomerOrders/components/OpenSalesOrdersTabPanel/OpenSalesOrdersTabPanel"
import { salesOrderSearchSchema } from "@/screens/CustomerOrders/schemas"

export const Route = createFileRoute("/app/orders/$companyId/$shipToLocationId/_layout/open-sales-orders")({
  validateSearch: zodValidator(salesOrderSearchSchema),
  component: OpenSalesOrdersTabPanel,
})
